<script>
import {BBadge} from 'bootstrap-vue'
import MoreElements from "@/views/product/components/product-card/composition/substance/details/view/MoreElements.vue";
export default {
    components: {MoreElements, BBadge},
    props: {
        substance: {
            required: true,
            type: Object,
        },
        details: {
            required: true,
            type: Array,
        },
        mode: {
            required: true
        }
    },
    methods: {
        makeTitleList(kind) {
            const elements = [];
            this.details
                .filter(d => d.hasOwnProperty(kind) && d[kind])
                .forEach(d => {
                    if (!elements.includes(d[kind].title)) {
                        elements.push(d[kind].title);
                    }
                });

            if (elements.length === 0) {
                elements.push('-')
            }

            return elements;
        }
    },
    computed: {
        concentrationRanges() {
            return this.makeTitleList('concentrationRange');
        },
        exemption() {
            return this.details
                .filter(d => d.exemption)
                .map(d => d.exemption)
                .join('; ');
        }
    }
}
</script>

<template>
    <div>
        <h5>{{ $t('Component(CompositionSubstance):scip-interval') }}</h5>
        <MoreElements visibleCount="2" class="mb-1" :elements="concentrationRanges">
            <template #list="data">
                <ul class="pl-0 ml-1">
                    <li v-for="element in data.elements">{{ element }}</li>
                </ul>
            </template>
        </MoreElements>

        <h5>{{ $t('Component(CompositionSubstance):rohs-exemption') }}</h5>
        <div class="mb-1">{{ exemption ? exemption : '-' }}</div>
    </div>
</template>

